import { gql, useQuery } from '@apollo/client';
import React, { useEffect } from 'react';
import { useDispatch, useI18n, useSelector } from '~Hooks';
import * as actions from '../../actions';
import useModal from '~ComponentsImproved/Modal/useModal';
import Modal from '~ComponentsImproved/Modal';
import { Buttons, LargePopupContent } from './styles';
import Button from '~ComponentsImproved/Button';
import { useStorage } from '~Components/Storage';
import { useLocation } from 'react-router';

const GET_ITEMS_COUNT = gql`
  query GetItemsCount($companyId: String!) {
    getItems(companyId: $companyId) {
      count
    }
  }
`;

const DemoHandler = () => {
  const demoMode = useSelector((state) => state.demoMode);
  const companyId = useSelector((state) => state.company);
  const dispatch = useDispatch();
  const infoModal = useModal();
  const itemsCountQuery = useQuery(GET_ITEMS_COUNT, {
    variables: { companyId },
    skip: !companyId,
  });
  const location = useLocation();
  const isHandy = location.pathname.includes('handy');
  const isGateway = location.pathname.includes('gateway');
  const { i18n } = useI18n();
  const [storage, updateStorage] = useStorage();

  useEffect(() => {
    if (itemsCountQuery.data && itemsCountQuery.data.getItems.count < 3 && !storage.hideDemoMode) {
      dispatch({
        type: 'SET_POS_LAYOUT',
        POSLayout: window.DEMO_MODE_LAYOUT_ID,
      });
      dispatch(actions.setDemoMode(true));
    }
  }, [itemsCountQuery]);

  useEffect(() => {
    if (demoMode && !isHandy && !isGateway) {
      infoModal.toggle();
    }
  }, [demoMode]);

  const exitDemoMode = () => {
    dispatch(actions.setDemoMode(false));
    infoModal.toggle();
    dispatch({
      type: 'SET_POS_LAYOUT',
      POSLayout: null,
    });
    updateStorage({ hideDemoMode: true });
  };

  const startExploring = () => {
    infoModal.toggle();
  };

  return (
    <Modal isShowing={infoModal.isShowing} hide={infoModal.toggle}>
      <LargePopupContent>
        <h2>{i18n('DemoMode.Title')}</h2>
        <p>{i18n('DemoMode.Text')}</p>
        <Buttons>
          <Button styleType="Gray" width="160px" onTouchStart={exitDemoMode}>
            {i18n('DemoMode.ExitMode')}
          </Button>
          <Button width="200px" styleType="OK" onTouchStart={startExploring}>
            {i18n('DemoMode.ExploreButton')}
          </Button>
        </Buttons>
      </LargePopupContent>
    </Modal>
  );
};

export default DemoHandler;
